<div class="modal-header blue">
  <h4 class="modal-title">Cignal (PPA, PPO, HMO)</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<div class="modal-body pl-0 pr-0">
  <table class="standart-table">
    <tbody>
      <ng-container>
        <tr>
          <td>
            <div class="file-icon mr-0">
              <i class="fas fa-file-download"></i>
            </div>
          </td>
          <td>
            <label class="black">Group</label>
            <div>
              <!-- {{ era.id || 'N/A'}} -->
            </div>
          </td>
          <td>
            <label class="black">File name</label>
            <div
              class="text-truncate"
              [title]="era.outputFilename"
              style="width: 140px"
            >
              {{ era.outputFilename }}
            </div>
          </td>
          <td>
            <label class="black">upload name</label>
            <div
              class="text-truncate"
              [title]="era.inputFilename"
              style="width: 140px"
            >
              {{ era.inputFilename }}
            </div>
          </td>
          <td>
            <label class="black">size</label>
            <div>---</div>
          </td>
          <td>
            <label class="black">date</label>
            <div>
              {{ era.dateReceived | date: 'MM/dd/yyyy' }}
            </div>
          </td>
          <td>
            <div class="d-flex">
              <div
                ngbDropdown
                container="body"
                placement="left"
                [autoClose]="'outside'"
              >
                <a
                  href="javascript: void(0)"
                  class="standart-link-action"
                  ngbDropdownToggle
                >
                  <i class="fas fa-chevron-circle-down"></i>
                </a>

                <div class="padding-right" ngbDropdownMenu>
                  <div class="dropdown-menu-inside">
                    <div ngbDropdownItem class="with-sub-menu">
                      <div ngbDropdown container="body" placement="left-top">
                        <div ngbDropdownToggle>Status</div>

                        <div ngbDropdownMenu class="select padding-right">
                          <div class="dropdown-menu-inside">
                            <button
                              ngbDropdownItem
                              *ngFor="let status of statuses"
                            >
                              <label class="dropdown-item-select">
                                <input
                                  type="radio"
                                  name="status"
                                  (change)="changeStatus(era, status)"
                                />
                                <span class="text">{{ status }}</span>
                              </label>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button ngbDropdownItem>View File</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
